import React, { useState } from 'react';
import AppoinmentModal from './AppoinmnetModal';



const ConsultCard = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const steps = [
        {
            icon: <img src={require('../../src/assets/images/consulticon2.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Comprehensive Profiling',
            description: 'We begin by gathering detailed insights into your lifestyle, dietary habits, and wellness objectives.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon1.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Medical & Genetic History Assessment',
            description: 'A deep dive into your personal and familial health patterns to uncover potential predispositions.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon4.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Identifying Core Health Concerns',
            description: 'Whether addressing metabolic imbalances, digestive health, or performance optimization, we align the strategy to your specific needs.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon3.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Advanced Diagnostic Testing',
            description: ' We recommend advanced pathological testing to gain a comprehensive understanding of your biochemistry.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon6.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Precision Sample Collection',
            description: 'Blood or saliva samples are obtained for in-depth biomarker analysis. For Nutrigenomics and Gut Microbiome testing, either a blood or stool sample is collected.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon5.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Body Blueprint Analysis',
            description: 'A sophisticated evaluation of your unique physiological composition and its impact on your nutritional needs. We recommend getting your body composition analysis done either at home or by visiting a nearby healthcare center or gym.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon7.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Program Initiation (Day 1)',
            description: 'Utilizing existing reports, we implement a structured pre-nutritional regimen with initial modification.'
        },
        {
            icon: <img src={require('../../src/assets/images/consulticon8.png')} alt="Comprehensive Profiling GIF" className="w-[60px] h-[60px]" />,
            title: 'Tailored Nutrition Plan (Post-Analysis)',
            description: 'Once all diagnostic results are in, we refine your program with a scientifically calibrated, highly personalized strategy designed for sustained well-being.'
        }
    ];

    return (
        <div className="bg-[#f2efed] pt-80 pb-80 custom-padding xl-screen-padding">
            <h1 className="text-4xl client-text text-center mb-10">How It Works</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {steps.map((step, index) => (
                    <div key={index} className="bg-white shadow-lg p-6 rounded-3xl w-[280px] consultcardsize text-center border-[1px] border-gray-300">
                        <div className="flex justify-center items-center text-5xl mb-4">
                            {step.icon}
                        </div>
                        <h2 className="text-md text-[#444444] client-text font-semibold mb-2">{step.title}</h2>
                        <p className="text-[#a2a8ad] text-sm client-text">{step.description}</p>
                    </div>
                ))}
            </div>
            <section className="pt-80 pb-80">
                <div
                    className="w-full h-[50vh] flex justify-center items-center flex-col"
                    style={{
                        background: 'linear-gradient(to right, #fff1c6, #cccccc, #dac587, #f2fded)',
                        animation: 'gradientBackground 15s ease infinite',
                        borderRadius: '70px',
                        overflow: 'hidden',
                    }}
                >
                    <div className="custom-padding xl-screen-padding text-center px-4">
                        <h1 className="text-xl sm:text-2xl md:text-2xl  font-semibold text-gray-800 client-text">
                            Every step is rooted in pioneering research and precision nutrition, ensuring that your health
                            journey is strategic, data-driven, and results-oriented.
                        </h1>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6">
                        <a href="https://wa.me/+919557439399" target="_blank" rel="noopener noreferrer">
                            <button className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto">
                                Get Started
                            </button>
                        </a>
                        <button
                            onClick={openModal}

                            className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                        >
                            Contact Us
                        </button>
                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

                    </div>
                </div>
            </section>

        </div>
    );
};

export default ConsultCard;
